import { Card, CardBody, Col, Container, Row } from "reactstrap";
import { Image, P } from "../../AbstractElements";
import { SampleCards, SamplePage } from "../../utils/Constant";
import Breadcrumbs from "../../CommonElements/Breadcrumbs/Breadcrumbs";
import CommonCardHeader from "../../CommonElements/CommonCardHeader/CommonCardHeader";
import { dynamicImage } from "../../Service";
import VersementTableau from "./VersementTableau";
import CarburantTableau from "./CarburantTableau";

const SamplePageContainer = () => {
  return (
    <>
      <Breadcrumbs mainTitle="TABLEAU DE BORD" parent={'ETS D ET F'} />
      <Container fluid>
        <VersementTableau />
        {/* <CarburantTableau /> */}
      </Container>
    </>
  );
};

export default SamplePageContainer;
